import axios from 'axios'

export const API = import.meta.env.VITE_API_URL || 'http://localhost:4000'

// X-Requested-With is required by the server on cookie-authenticated writes (see the
// router): sandboxed code cannot send it, so it cannot act with the user's session.
export const stApi = axios.create({
  baseURL: `${API}/api/st-diagnostic`,
  withCredentials: true,
  headers: { 'X-Requested-With': 'XMLHttpRequest' }
})

export const practiceApi = axios.create({
  baseURL: `${API}/api/st-practice`,
  withCredentials: true,
  headers: { 'X-Requested-With': 'XMLHttpRequest' }
})

export function errorMessage(err, fallback = 'Something went wrong') {
  return err?.response?.data?.error || err?.message || fallback
}

// STUN is enough on most networks; set a TURN server for strict corporate/campus NATs.
export function iceServers() {
  const servers = [{ urls: 'stun:stun.l.google.com:19302' }]
  if (import.meta.env.VITE_TURN_URL) {
    servers.push({
      urls: import.meta.env.VITE_TURN_URL,
      username: import.meta.env.VITE_TURN_USERNAME,
      credential: import.meta.env.VITE_TURN_CREDENTIAL
    })
  }
  return servers
}
